import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useStudentLovedBulk(degreeIds)
 * -----------------------------------------------------------------------------
 * Fetches student-satisfaction aggregates for a list of degree IDs in a
 * single POST /api/satisfaction/bulk call. Returns a map:
 *   { [degree_id]: { count, averages, student_loved } }
 *
 * Callers only need `map[id]?.student_loved` in most cases — but the full
 * object (count + averages) is exposed for tooltip content.
 *
 * Silent-fail: if the endpoint errors, the map stays `{}` and every card
 * simply renders without the badge (no console noise, no toasts).
 */
export function useStudentLovedBulk(degreeIds) {
  const [map, setMap] = useState({});

  useEffect(() => {
    const ids = Array.from(new Set((degreeIds || []).filter(Boolean)));
    if (ids.length === 0) {
      setMap({});
      return;
    }
    let cancelled = false;
    api
      .post("/satisfaction/bulk", { degree_ids: ids })
      .then((r) => {
        if (!cancelled) setMap(r.data || {});
      })
      .catch(() => {
        if (!cancelled) setMap({});
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Array.from(new Set((degreeIds || []).filter(Boolean))).sort().join("|")]);

  return map;
}
